/* eslint-disable no-unused-vars */
import ShiftRecordBlockType from '@/constants/booking/ShiftRecordBlockType'

/**
 * @class
 * @public
 */
export default class ShiftRecordBlock {
  constructor({
    type,
    startTime,
    endTime,
    timeEntryStartTime = null,
    timeEntryEndTime = null,
  } = {}) {
    /**
     * Determines if the shiftRecord has been submitted or not
     * @type {keyof ShiftRecordBlockType}
     */
    this.type = type
    /**
     * Start time of block in 24 hr format
     * @type {String}
     * @example 08:30
     */
    this.startTime = startTime
    /**
     * End time of block in 24 hr format
     * @type {String}
     * @example 15:30
     */
    this.endTime = endTime
    /**
     * The recorded time entry start time
     * @type {Nullable<String>}
     * @example 08:27
     */
    this.timeEntryStartTime = timeEntryStartTime
    /**
     * The recorded time entry end time
     * @type {Nullable<String>}
     * @example 15:46
     */
    this.timeEntryEndTime = timeEntryEndTime
    /**
     * Indicates if the block has a scheduled start and end time.
     * The backend will return `00:00` for both startTime and
     * endTime if there isn't a scheduled time set.
     *
     * This should indicate to the candidate timesheet/shift record
     * UI not to display the scheduled time hint.
     *
     * @type {boolean}
     */
    this.hasScheduledTime =
      this.startTime !== '00:00' && this.endTime !== '00:00'
  }
}
